import { Chances } from '@/features/chances/chances'
import { client } from '@/features/query/client'
import { createFileRoute } from '@tanstack/react-router'
import {
  getUserControllerGetMeQueryKey,
  userControllerGetMe,
} from '@/api/users/users'
import CoinAnimation from '@/ui/loader'

export const Route = createFileRoute('/chances')({
  component: RouteComponent,
  loader: async () => {
    return Promise.allSettled([
      client.prefetchQuery({
        queryKey: getUserControllerGetMeQueryKey(),
        queryFn: () => userControllerGetMe(),
      }),
    ])
  },
  pendingComponent: CoinAnimation,
})

function RouteComponent() {
  return <Chances />
}
